import { InfoCircleOutlined } from '@ant-design/icons';
import { FormItemProps } from 'antd';
import { useTranslation } from 'react-i18next';

const PasswordTitle = () => {
  const { t } = useTranslation();
  const pwContent = t('authentication.passwordInformation.content').split('\n');

  return (
    <div style={{ padding: '8px 12px' }}>
      <strong>{t('authentication.passwordInformation.title')}</strong>
      {pwContent.map(content => (
        <div key={content}>{content}</div>
      ))}
    </div>
  );
};

const passwordTooltip: FormItemProps['tooltip'] = {
  icon: (
    <InfoCircleOutlined style={{ cursor: 'unset', color: 'var(--link)' }} />
  ),
  title: <PasswordTitle />,
  color: 'whitesmoke',
  overlayInnerStyle: { color: 'var(--color)', minWidth: 350 },
};

export default passwordTooltip;
